export default __webpack_public_path__ + "static/headshot-dan-2ad543f236b8d1ab4ef4b7dab3ad3626.jpg";